import { render } from "./UserRegister.vue?vue&type=template&id=afe7d074"
import script from "./UserRegister.vue?vue&type=script&lang=js"
export * from "./UserRegister.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gimmetm/work/projects/tnms-go/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__